import { LinkCreationService } from '@sportal365/smp-widget-utils';
import { createContext } from 'react';
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';

const LinkServiceContext = createContext<{
  linkService?: LinkCreationService | null | undefined;
  urlTarget?: typeof TARGET_BLANK | typeof TARGET_SELF;
}>({});

export default LinkServiceContext;
